module.exports = fox._r("images/slide-image-2.jpg", __webpack_public_path__ + "images/slide-image-2.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/slide-image-2.jpg
// module id = 945
// module chunks = 4